import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaUserResolver_GetLeadTrackStatus = UsersTableDefinitionZod.shape.assignable.nullish();

export type SchemaUserResolver_GetLeadTrackStatus = z.infer<typeof schemaUserResolver_GetLeadTrackStatus>;

export type UserResolver_GetLeadTrackStatus = Resolver<Arguments, SchemaUserResolver_GetLeadTrackStatus>;
